import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { SingleFileuploadTitle } from "../../../../Utils/Constants";

export default function SingleFileupload() {
  return (
    <Col lg={6}>
      <Card>
        <CommonCardHeader title={SingleFileuploadTitle} />
        <CardBody>
          <CommonFileUpload />
        </CardBody>
      </Card>
    </Col>
  );
}
